import "./Main.css";
import React from "react";
import HelpPictures from "../../assets/army1.jpg";
import HelpPic from "../../assets/help.png";
import IconHand from "../../assets/help-icon-hand.svg";
import BtnGroup from "../BtnGroup/BtnGroup";
import { t } from "i18next";

export default function Help() {
  const directions = [1, 2, 3, 4, 5, 6];

  return (
    <section className="skyua-main-section">
      <div className="skyua-main-container">
        <div className="skyua-main-heading">
          <span className="skyua-main-eyebrow">{t("help title")}</span>
          <h2>
            {t("home help heading") !== "home help heading"
              ? t("home help heading")
              : "Працюємо за шістьма ключовими напрямами"}
          </h2>
        </div>

        <div className="skyua-help-home-grid">
          <div className="skyua-help-collage">
            <img
              src={HelpPictures}
              alt="help"
              className="skyua-help-collage__main"
            />

            <div className="skyua-help-collage__accent" />

            <img
              src={HelpPic}
              alt="help"
              className="skyua-help-collage__secondary"
            />
          </div>

          <div className="skyua-help-panel">
            <span className="skyua-main-eyebrow skyua-main-eyebrow--dark">
              {t("home directions eyebrow") !== "home directions eyebrow"
                ? t("home directions eyebrow")
                : "Напрями роботи"}
            </span>

            <h3>{t("help second title")}</h3>
            <p>{t("help p")}</p>

            <ul className="skyua-help-list">
              {directions.map((number) => (
                <li key={number}>
                  <img src={IconHand} alt="" />
                  <span>{t(`help list-item ${number}`)}</span>
                </li>
              ))}
            </ul>

            <div className="skyua-help-actions">
              <BtnGroup />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
